<template>
  <div id="app">
    <mq-layout :mq="['lg']">
        <!-- <kspBar /> -->
        <top />
        <megamenu />
    </mq-layout>
    <mq-layout :mq="['xs', 'sm', 'md']">
        <searchDialog v-if="showMobileSearch" @hideSearch="showMobileSearch=false" />
        <!-- <mobileExtraTop @showSearch="showMobileSearch=true"/> -->
        <top @toggleMobileMenu="burgerMenuOpen = !burgerMenuOpen" />
        <burgermenu :open="burgerMenuOpen" @closeMenu="burgerMenuOpen = false" />
    </mq-layout>
    
    <div class="site-content">
        <div class="routerViewContainer">
            <router-view/>
        </div>
        <mq-layout :mq="['sm', 'md', 'lg']">
            <shopFooter/>
        </mq-layout>
        <mq-layout :mq="['xs']">
            <shopFooterMobile />
        </mq-layout>
    </div>
    <buyMorePopup v-if="showBuyMore" :product="showBuyMoreProduct" @close="showBuyMore=false" :color="showBuyMoreSelectedColor"/>
    <ageWarning />
    <script v-if="jsonldBreadCrumb" v-html="jsonldBreadCrumb" type="application/ld+json" />
    <script v-if="jsonldProduct" v-html="jsonldProduct" type="application/ld+json" />
  </div>
</template>
<script>
import top from "./components/top.vue";
import kspBar from "./components/KSPbar.vue";
import footer from "./components/footer.vue";
import footerMobile from "./components/footer.mobile.vue";
let buyMorePopup = () => import(/* webpackChunkName: "componentBuyMorePopoup" */ './components/buyMorePopup.vue');
import axios from "axios";
import basketService from "./services/basketService.vue";
import imageService from "./services/imageService.vue";
import ageWarning from "./components/ageWarning.vue";
export default {
    components:{
        megamenu : ()=>import(/* webpackChunkName: "componentMegamenu" */ './components/megamenu.vue'),
        burgermenu : ()=>import(/* webpackChunkName: "componentBurgermenu" */ './components/burgermenu.vue'),
        mobileExtraTop : ()=>import(/* webpackChunkName: "componentMobileExtraTop" */ './components/mobileExtraTop.vue'),
        searchDialog : () => import(/* webpackChunkName: "componentSearchDialog" */ './components/mobileExtraTop.search.vue'),
        top,
        kspBar,
        shopFooter : footer,
        shopFooterMobile : footerMobile,
        buyMorePopup,
        ageWarning
    },
    mounted(){
        this.$root.$on('pagedata', async (pagedata) => {
            // console.log("onPagedata", pagedata);

            this.jsonldBreadCrumb = !pagedata.breadCrumb ? null : {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": pagedata.breadCrumb.map((item,index)=>({
                    "@type": "ListItem",
                    "position": index+1,
                    "name" : item.text,
                    "item" : document.location.origin + item.to
                }))
            };
            
            function getUnitPrice(product){
                if(product.SalePrices && product.SalePrices[0] && product.SalePrices[0].MinQuantity == 1)
                    return product.SalePrices[0];
                return {
                    UnitPrice : product.UnitPrice,
                    IsTilbud : false,
                    End : null,
                }
                //450022215
            }
            
            if(pagedata.product && pagedata.product.Type == "Product")
            {
                var images = await imageService.getImages(pagedata.product.No);
                this.jsonldProduct = {
                    "@context": "https://schema.org/", 
                    "@type": "Product", 
                    "name": pagedata.product.Description,
                    "image": (images && images.length>0) ? `${document.location.origin}/ProductImages/${pagedata.product.No}/800/${images[0]}.jpg` : null,
                    "description": pagedata.product.LongText,
                    "brand": pagedata.product.WebBrandName,
                    "sku": pagedata.product.No,
                    "offers": {
                        "@type": "Offer",
                        "url": document.location.href,
                        "priceCurrency": "DKK",
                        "price": getUnitPrice(pagedata.product).UnitPrice,
                        "priceValidUntil": getUnitPrice(pagedata.product).End,
                        "availability": "https://schema.org/InStock",
                        "itemCondition": "https://schema.org/NewCondition"
                    }
                }
            }
            else if(pagedata.product && pagedata.product.Type == "ProductGroup")
            {
                var images = await imageService.getImages(pagedata.product.No);
                this.jsonldProduct = {
                    "@context": "https://schema.org/", 
                    "@type": "Product", 
                    "name": pagedata.product.Description,
                    "image": (images && images.length>0) ? `${document.location.origin}/ProductImages/${pagedata.product.No}/800/${images[0]}.jpg` : null,
                    "description": pagedata.product.LongText,
                    // "brand": "brand",
                    // "sku": "12345",
                    "offers": pagedata.product.Products.map(p=>({
                        "@type": "Offer",
                        "url": document.location.href,
                        "sku": p.No,
                        "name": p.Description,
                        // "price": p.UnitPrice,
                        "price": getUnitPrice(p).UnitPrice,
                        "priceValidUntil": getUnitPrice(p).End,
                        "priceCurrency": "DKK",
                        "availability": "https://schema.org/InStock",
                        "itemCondition": "https://schema.org/NewCondition"
                    }))
                }
            }
            else
                this.jsonldProduct = null;
        });
        this.$root.$on("showBuyMore",async (itemUrlOrProduct, count)=>{
            this.showBuyMore = false;
            if(typeof(itemUrlOrProduct) == "string")
            {
                var productPage = await axios.get(itemUrlOrProduct + "?altTemplate=pagedata");
                itemUrlOrProduct = productPage.data.product;
                basketService.addItem(productPage.data.product, count, null);
            }
            this.showBuyMoreProduct = itemUrlOrProduct;
            this.$nextTick(()=>{
                this.showBuyMore = true;
            })
        })
    },
    data(){
        return {
            burgerMenuOpen : false,
            showBuyMore : false,
            showBuyMoreProduct : null,
            showBuyMoreSelectedColor : null,
            jsonldBreadCrumb : null,
            jsonldProduct : null,
            showMobileSearch : false
        };
    }
};
</script>
<style lang="scss">
// Required
// $font-family-sans-serif: Utsaah, Arial, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !default;
$font-family-sans-serif: "Open Sans",sans-serif !default;

// $grid-breakpoints: (
//   xs: 0,
//   sm: 576px,
//   md: 768px,
//   lg: 992px,
//   xl: 1200px
// ) !default;

$container-max-widths: (
  sm: 540px,
  md: 720px,
  lg: 990px,
  xl: 1180px
) !default;

$dark : #212529;
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins";
@import "colors";

$theme-colors: (
  "primary": $rkPrimary,
);
$link-color: $dark;
$link-hover-color: darken($rkBrown, 0%);

@import "~bootstrap/scss/bootstrap";
// @import '~bootstrap-vue/dist/bootstrap-vue.css';
    @media (max-width: 767px) { // https://github.com/twbs/bootstrap/pull/25631
        .container{
            width: 100%;
            max-width:unset;
            padding-right: ($grid-gutter-width / 2);
            padding-left: ($grid-gutter-width / 2);
            margin-right: auto;
            margin-left: auto;
        }
    }
    body{
        font-size:13px;
        overflow-x:hidden;
    }
    #app {
        display: flex;
        min-height: 75vh;
        flex-direction: column;
    }
    a{
        text-decoration: none !important;
        // color:#646464;
    }
    .site-content {
        flex: 1;
        .routerViewContainer{
            min-height: 100vh;
        }
    }
    .pointer{
        cursor:pointer;
    }

    @import "./colors";
    .modal-header{
        padding: 0.25rem 1rem;
        border-bottom:none;
        background-color:$rkPrimary !important;
        color:white;
        h5{
            margin:0 auto;
        }
        .close{
            margin:0 -0.5rem 0 0;
            padding:0;
            color:white;
            opacity: unset;
        }
    }
    .modal-backdrop{
        opacity: 0.6;
    }

    .bundText{
        color:#646464;
        margin-top:50px;
        padding:15px 0 10px;
        border-top:solid 2px #CDCDCD;
        // border-left:none;
        // border-right:none;
    }

    // @font-face {
    //     font-family: 'Steelfish Rg';
    //     src: url('~@/assets/fonts/SteelfishRg-Bold.woff2') format('woff2'),
    //         url('~@/assets/fonts/SteelfishRg-Bold.woff') format('woff'); 
    //     font-weight: bold;
    //     font-style: normal;
    // }

// @font-face {
//     font-family: 'Utsaah';
//     src: url('~@/assets/fonts/Utsaah.woff2') format('woff2'),
//         url('~@/assets/fonts/Utsaah.woff') format('woff');
//     font-weight: normal;
//     font-style: normal;
// }


@font-face {
    font-family: 'Steelfish Rg';
    src: url('~@/assets/fonts/SteelfishRg-Bold.woff2') format('woff2'),
        url('~@/assets/fonts/SteelfishRg-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'Steelfish Outline';
    src: url('~@/assets/fonts/SteelfishOutline-Regular.woff2') format('woff2'),
        url('~@/assets/fonts/SteelfishOutline-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Steelfish Rg';
    src: url('~@/assets/fonts/SteelfishRg-BoldItalic.woff2') format('woff2'),
        url('~@/assets/fonts/SteelfishRg-BoldItalic.woff') format('woff');
    font-weight: bold;
    font-style: italic;
}

@font-face {
    font-family: 'Steelfish Eb';
    src: url('~@/assets/fonts/SteelfishEb-Regular.woff2') format('woff2'),
        url('~@/assets/fonts/SteelfishEb-Regular.woff') format('woff');
    font-weight: 900;
    font-style: normal;
}

@font-face {
    font-family: 'Steelfish Rg';
    src: url('~@/assets/fonts/SteelfishRg-Italic.woff2') format('woff2'),
        url('~@/assets/fonts/SteelfishRg-Italic.woff') format('woff');
    font-weight: normal;
    font-style: italic;
}

@font-face {
    font-family: 'Steelfish Rg';
    src: url('~@/assets/fonts/SteelfishRg-Regular.woff2') format('woff2'),
        url('~@/assets/fonts/SteelfishRg-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Steelfish Eb';
    src: url('~@/assets/fonts/SteelfishEb-Italic.woff2') format('woff2'),
        url('~@/assets/fonts/SteelfishEb-Italic.woff') format('woff');
    font-weight: 900;
    font-style: italic;
}
</style>
